import CONFIG from '@/config/config.ts';
import axios from 'axios';

type Token = {
  headerName: 'X-CSRF-TOKEN';
  parameterName: '_csrf';
  token: string;
};

export const getCsrfToken = async (): Promise<string> => {
  const res = await axios.get<Token>(`${CONFIG.HOST}/api/csrf`, {
    headers:
      CONFIG.ENVIRONMENT === 'local'
        ? {
            'x-auth-token': `${CONFIG.JSESSION}`,
          }
        : {},
  });
  return res.data.token;
};
